export const CLOSED_WON_REPORT = {
  headline: 'Kestrel Bank · $210,000 — kickoff drafted',
  status: 'done',
  durationSec: 33,
  body: `**Kestrel Bank closed — $210,000, two-year renewal.**

- Posted to **#wins**: owner Rhea Kapoor; we won on data-residency support against Metricly.
- Created **Kestrel Bank — Onboarding** in Notion with the 9-step checklist.
- Drafted a kickoff email to **Hannah Cole** (Head of Analytics) proposing a call next week — it’s in your drafts.`,
}
